/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ActivityPageInternalRequest} from '@cash-web/protos/squareup/cash/activity/api/v1/service.pb'
import {ActivityPageInternalResponse} from '@cash-web/protos/squareup/cash/activity/api/v1/service.pb'


export const activityPageInternal = (request:ActivityPageInternalRequest, options?: CashRequestOptions) => post<ActivityPageInternalRequest, ActivityPageInternalResponse>("/2.0/cash/activity-page-internal", request, {...options, rejectOnError: true })